<template>
    <StepForm v-if="!hideRegistrationForm">
        <navigation  v-if="!failRegistration" :steps="steps" iconType="step" :showBackBtn="true" />
        <div class="form__content">
            <stepOne v-if="activeStep == 1" />
            <stepTwo v-if="activeStep == 2" />
            <stepThree v-if="activeStep == 3" />
            <stepFour v-if="activeStep == 4" />
            <div class="form-finish-section" v-if="finishRegistrationLoader">
                {{ __('Finishing Registration. Please Wait!') }}
                <Loader color="#2563eb" />
            </div>
            <Modal class="popup--contact" :isActive="failRegistration" @close="failRegistration = false">
                <template #head>
                    <div class="popup__icon">
                        <img :src="`${theme_path.url}/resources/images/svg/icon-support.svg`" alt="">
                    </div>
                
                    <h3 class="popup__title">
                        {{ __('There is an issue with the credit card entered!') }}
                    </h3>
                    <h4 class="popup__subtitle">
                        {{ __('Payment cannot be processed.') }}
                    </h4>
                </template>
                <template #body>
                    {{ __('Please contact the bank branch or enter valid credit card details.') }}
                    <button type="btn btn--fullwidth" @click="reTryRegistration()">
                        {{ __('Approval') }}
                    </button>
                </template>
            </Modal>
        </div><!-- /.form__content -->
    </StepForm>
    <SuccessPage v-if="showSuccessPage"/>
    <RegistrationActivationForm v-if="startActivation"/>
</template>

<script setup>
import { provide, ref, watch, onMounted } from "vue";
import { formFragmentValues, setFormFragmentValues, registrationID, __, getFormValuesFromLocalStorage, retrieveUrlParameter } from '@/utils'
import StepForm from '@components/step-form.vue';
import RegistrationActivationForm from '@components/RegistrationActivationForm/RegistrationActivationForm.vue';
import SuccessPage from '@components/successPage.vue';
import stepOne from '@components/stepOne/step-one.vue';
import stepTwo from '@components/stepTwo/step-two.vue';
import stepThree from '@components/stepThree/step-three.vue';
import stepFour from '@components/stepFour/step-four.vue';
import navigation from '@components/stepsNavigation.vue';
import Loader from '@components/loader.vue';
import Modal from "@components/modal.vue";

if(retrieveUrlParameter('plan_id')){
    localStorage.removeItem('formValues');
    localStorage.removeItem('formFragmentValues');
}

const localValues = formFragmentValues();
const activeStep = ref(localValues.activeStep ? parseInt(localValues.activeStep) : 1);
const validSteps = ref({
    1: false,
    2: false,
    3: false,
    4: false
})

const steps = [
	{ title: __('Choose a number') },
	{ title: __('Fill in details') },
	{ title: __('Confirm Order') },
	{ title: __('Payment') }
];

const localStorageValues = getFormValuesFromLocalStorage();
const plans = ref([]);
const activeValidationSchema = ref(localValues.activeValidationSchema ? parseInt(localValues.activeValidationSchema) : 1);
const setActiveStep = (step) => {
    activeStep.value = step
};
const nextStep = () => activeStep.value + 1;
const currStep = () => activeStep.value;
const prevStep = () => activeStep.value - 1;
const setValidStep = (value) => validSteps.value[activeStep.value] = value;
const isTargetStepValid = (step) => validSteps.value[step];
const setPlans = (data) => plans.value = data;

const startActivation = ref(localValues.startActivation ? localValues.startActivation : false);
const hideRegistrationForm = ref(localValues.hideRegistrationForm ? localValues.hideRegistrationForm : false);
const showSuccessPage = ref(localValues.showSuccessPage ? localValues.showSuccessPage : false);
const finishRegistrationLoader = ref(false);
const failRegistration = ref(false);
const failPayment= ref(false);
const registrationData = ref({});
const progressUpdate = ref(false);

const handleRegistrationData = (data) => registrationData.value = data;

const handleSuccessPage = () => {
    startActivation.value = false
    showSuccessPage.value = true;
    setFormFragmentValues({
        showSuccessPage: true
    });
}

const reTryRegistration = () => {
    activeStep.value = 1;
    failRegistration.value = false;
}

if (!localValues.registrationID?.length) {
    setFormFragmentValues({
        registrationID: registrationID()
    });
}

if (localStorageValues.subscriberSendSimToAddress === undefined) {
    localStorageValues.subscriberSendSimToAddress = true;
    localStorage.setItem('formValues', JSON.stringify(localStorageValues));
}

if (localStorageValues.companySendSimToAddress === undefined) {
    localStorageValues.companySendSimToAddress = true;
    localStorage.setItem('formValues', JSON.stringify(localStorageValues));
}

if (!localValues?.lastStep) {
    setFormFragmentValues({
        lastStep: 4
    });
}


watch(activeStep, (newVal) => {
    setFormFragmentValues({
        activeStep: newVal
    })
});

watch(activeValidationSchema, (newSchema) => {
    setFormFragmentValues({
        activeValidationSchema: newSchema
    })
});

onMounted(() => {
    document.body.classList.remove('loading');
});

provide('step', {
    activeStep,
    activeValidationSchema,
    setActiveStep,
    nextStep,
    prevStep,
    startActivation,
    showSuccessPage,
    handleSuccessPage,
    hideRegistrationForm,
    finishRegistrationLoader,
    failRegistration,
    failPayment,
    validSteps,
    setValidStep,
    isTargetStepValid,
    plans,
    setPlans,
    currStep,
    registrationData,
    handleRegistrationData,
    progressUpdate
});
</script>
